import {companyFeaturesConstants} from '../../constants';
import {useCompanyFeatureAvailable} from './useCompanyFeatureAvailable';

const featureName = companyFeaturesConstants.ACCOUNTING_MODULE;

/**
 * Checks if the accounting module is available for the company.
 *
 * @returns {boolean} True when the `accounting_module` company feature is enabled.
 *
 * @example
 * const isAccountingAvailable = useIsAccountingAvailable();
 */
export const useIsAccountingAvailable = () => {
  return useCompanyFeatureAvailable(featureName);
};
